{
  "actions": "Acties",
  "hideButtonLabel": "Minder weergeven",
  "noTags": "Geen",
  "showAllButtonLabel": "Alles tonen ({tagCount, number})"
}
